// extracted by mini-css-extract-plugin
export default {"section":"retry-add-credential_section__3GSP3","image":"retry-add-credential_image__wTX9l"};